import type { JSX } from 'react'
type Props = {
    children: JSX.Element | JSX.Element[] | null
}

export const ComponentWrap = ({ children }: Props) => {
    // return <div className="m-1 p-1 flex flex-col">{children}</div>
    return <>{children}</>
}
